import React from "react";
import PropTypes from "prop-types";
import UserImage from "../../assets/images/users-circ.png";

const UserDropdown = ({
                        userRole,
                        isOpen,
                        onToggle,
                      }) => {
  return (
    <div className="dropdown">
      <div onClick={onToggle} aria-expanded={isOpen}>
        <div className="admin-user">
          <figure>
            <img src={UserImage} width="40" alt="User" />
          </figure>
          <section>

            <small>{userRole}</small>
          </section>

        </div>
      </div>

    </div>
  );
};

UserDropdown.propTypes = {
  userName: PropTypes.string.isRequired,
  userRole: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  hoveredIndex: PropTypes.number,
  onHover: PropTypes.func.isRequired,
};


export default UserDropdown;
